import { render } from "./ProjectSubHeader.vue?vue&type=template&id=3e38abe8&scoped=true"
import script from "./ProjectSubHeader.vue?vue&type=script&lang=js"
export * from "./ProjectSubHeader.vue?vue&type=script&lang=js"

import "./ProjectSubHeader.vue?vue&type=style&index=0&id=3e38abe8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e38abe8"]])

export default __exports__